import NucleusComponentBase from '@/shared/application/nucleus-component-base';
import { Component } from 'vue-property-decorator';


export default class ContractLayoutComponent extends NucleusComponentBase {
   
}